var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('a-result',{attrs:{"status":"404","title":"404","sub-title":"页面不存在，请检查路径是否正确"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('ButtonField',{attrs:{"text":"返回上一页","primary":""},on:{"click":_vm.back}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }